<div *ngIf="src.startsWith('https://img.youtube')">
    <img [defaultImage]="defaultImage" [lazyLoad]="src" (onStateChange)="handler($event)" [offset]="500" [alt]="alt" id="image_variant">
    <div class="yt"></div>        
</div>

<div *ngIf="!src.startsWith('https://img.youtube')">
    <img [defaultImage]="defaultImage" [lazyLoad]="src" (onStateChange)="handler($event)" [offset]="500" [alt]="alt" id="image_variant">
</div>